import styled from 'styled-components';
import { ShadowBoxDark } from 'app/components';
import { RowButton } from '../styles';
export const StepSnacksAsideDetail = styled(ShadowBoxDark).attrs({
  className: 'b-step-snacks__aside'
})`
max-height:${({ selectedItems }) => selectedItems ? '360px' : 'none'};
overflow-y:${({ selectedItems }) => selectedItems ? 'scroll' : 'none'};
  // width: 329px;
  // height:694px;
  // // padding: ${({ theme }) => theme.indent.m};

  // ${RowButton} {
  //   text-align: center;
  // }
// display:flex;
.heading_detail{
    padding:10px;
    font-size: 18px;
    font-weight: 500;
    line-height: 25px;
}
.horizontal-line{
  margin:0px;
  border: 1px solid rgba(255, 255, 255, 0.08);
}
.section-aside{
  display:flex;
  align-Items:start;
  justify-content:space-between;
}
.main-section{
  display:flex;
  align-Items:start;
  gap:16px;
}
.sub-section{
  // width:70px;
  // height:70px;
  width:48px;
  height:48px;
  border-radius:8px;
  border:1px solid #4F4F4F;
  background-color:#454544;
  padding:5px;
  position:relative;
}
.img-items{
  // width:60px;
  // height:60px;
  width:100%;
  height:100%;
}

.sub-img{
  width:18px;
  height:18px;
  position:absolute;
  top:-8px;
  left:-10px;
  padding:4px;
  border-radius:50%;
  background-color:#DE1619;
  cursor:pointer;
}
.cross-icon{
  width:100%;
  height:100%;
}
.item-description{
  display: inline-block;
  max-width: 130px;
  font-size: 14px;
  line-height: 20px;
  color: #FFFFFFCC;
}
.total-main-section{
  display:flex;
  align-Items:end;
  flex-direction:column;
}
.sub-section-total{
  // opacity:0.8;
  color: #FFFFFFCC;
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
}
.total-amount{
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
}
.total-description{
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;  
}
.total-amount{
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
}
  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
    width: 100%;
    padding: 0;
    background: none;
    box-shadow: none;
    // display:none;
  }
`;